export default "__VITE_ASSET__Bj70ij_X__"